import { Repeat } from "lucide-react"
import getEventFrequency from "@/modules/calendar/utils/get-event-frequency"
import useUserEventSideSheet from "@/modules/calendar/stores/use-user-event-side-sheet"
import isARecurringEvent from "@/modules/calendar/utils/is-a-recurring-event"

export default function EventFrequency() {
  const { event, isDetails } = useUserEventSideSheet()

  if (!isARecurringEvent(event) || !isDetails) return null

  return (
    <div className="flex w-full items-center justify-start" title={getEventFrequency(event)}>
      <div className="flex w-full items-center gap-3">
        <Repeat className="!size-5 shrink-0 text-gray-500" />
        <div className="flex w-full items-center justify-start gap-1 truncate text-gray-600">
          <span className="text-sm font-normal">Frecuencia:</span>
          <span className="truncate text-sm font-semibold first-letter:capitalize">
            {getEventFrequency(event)}
          </span>
        </div>
      </div>
    </div>
  )
}
